module.exports = __webpack_public_path__ + "img/pay-layout-1.d3ed0d34.svg";